import { Component, OnInit, ViewChild } from '@angular/core';
import { Partner } from 'src/app/shared/models/clients/partner';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { PartnersModalComponent } from '../partners-modal/partners-modal.component';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/core/services/print.service';

@Component({
  selector: 'app-client-partners',
  templateUrl: './client-partners.component.html',
  styleUrls: ['./client-partners.component.scss']
})
export class ClientPartnersComponent implements OnInit {
  public partners: Partner[] = [];
  public clientId = null;
  public searchParams = new SearchParams();
  @ViewChild('partnerModal') partnerModal: PartnersModalComponent;

  constructor(
    private apiService: ClientsApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private printService: PrintService,
  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.clientId = resolversData.client.id;
    });
  }

  ngOnInit(): void {
    this.loadPartners();
  }

  loadPartners() {
    this.spinner.show();
    this.apiService.getClientPartners(this.searchParams, this.clientId).subscribe(
      c => {
        this.spinner.hide();
        this.partners = c.results;
      }
    )
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.searchParams.page = 1;
      this.searchParams.search = (e.target as HTMLInputElement).value;
      this.loadPartners();
    }
  }

  addNewPartner() {
    const partner = new Partner();
    partner.clientId = this.clientId;
    this.partnerModal.open(partner);
  }

  editPartner(partner: Partner) {
    this.partnerModal.open(partner);
  }

  partnerSubmit(partner: Partner) {
    let action = '';
    if (this.partners.find(n => partner.id === n.id)) {
      const i = this.partners.findIndex((value, index, array) => { return value.id === partner.id });
      this.partners[i] = partner;
      action = 'updated';
    } else {
      this.partners.push(partner);
      action = 'created';
    }
    this.partnerModal.close();
    this.toastr.success(`Partner ${action}`, 'Success!');
  }

  print() {
    this.route.parent.data.subscribe(resolversData => {
      this.printService.data = { partners: this.partners, clientName: resolversData.client.fullName };
      this.printService.printDocument('client-partners');
    });
  }
}